import { render } from "./PersonalAccounts.vue?vue&type=template&id=62013727&scoped=true"
import script from "./PersonalAccounts.vue?vue&type=script&lang=js"
export * from "./PersonalAccounts.vue?vue&type=script&lang=js"

import "./PersonalAccounts.vue?vue&type=style&index=0&id=62013727&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62013727"]])

export default __exports__